import React, { ReactNode } from "react";
import { ToasterProvider as StoreToasterProvider } from "userful-chronos-common-store/dist/toasts";

import AppToasts from "./AppToasts";

interface Props {
    children: ReactNode;
}

export default function ToasterProvider({ children }: Props) {
    return <StoreToasterProvider renderToasts={<AppToasts />}>{children}</StoreToasterProvider>;
}
